/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useRef, useEffect } from 'react';
import yn from 'yn';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clientbookApi } from '../../../../../../../../../core/clientbook-api';
import { notificationError, notificationSuccess } from '../../../../../../../../../core/actions';
import {
  setMsgClient,
  openConversation,
  setMsgResetClient,
  closeConversation,
  setMsgFollowers,
  updateFollowersConversation,
} from '../../../../../../../../../reducers/messaging';

const ChatMore = props => {
  const [associatesAssigned, setAssociatesAssigned] = useState([]);
  const [openChatOptions, setOpenChatOptions] = useState(false);
  const [elipsis, setElipsis] = useState(false);
  const [archived] = useState(!props?.chat?.isOpen);

  const isMounted = useRef(null);

  const MarkUnread = chat => {
    isMounted.current = true;
    (async () => {
      try {
        props.updateUnreadInInboxes(chat.id);
        await clientbookApi.patch({
          url: `/chats/${chat.id}`,
          data: { isRead: false },
        });
        setOpenChatOptions(false);
      } catch {
        notificationError('Error Setting Message as Unread');
      }
    })();
    return () => {
      isMounted.current = false;
    };
  };

  const archiveChat = async chat => {
    try {
      await clientbookApi.patch({
        url: `/chats/${chat.id}`,
        data: { isOpen: false },
      });
      if (props.messaging.client.chat_id === chat.id) {
        setMsgClient({ isOpen: false });
        setMsgResetClient();
      }
      closeConversation(chat.id);
      notificationSuccess('Conversation Closed');
    } catch {
      notificationError('Error closing conversation');
    }
  };

  const unarchiveChat = async chat => {
    try {
      await clientbookApi.patch({
        url: `/chats/${chat.id}`,
        data: { isOpen: true },
      });
      notificationSuccess('Conversation Opened');
      if (props.messaging.client.chat_id === chat.id) {
        setMsgClient({ isOpen: true });
      }
      openConversation(chat.id);
    } catch {
      notificationError('Error opening Chat');
    }
  };

  const joinConversation = async chat => {
    try {
      await clientbookApi.post({
        url: `/chats/${chat.id}/followers`,
        data: { associateId: props.auth.userId },
      });
      const updatedFollowers = [...chat.followers, props.auth.userId];
      notificationSuccess('Conversation Joined');
      if (props.messaging.client.chat_id === chat.id) {
        setMsgFollowers(updatedFollowers);
      }
      updateFollowersConversation(chat.id, updatedFollowers);
    } catch (error) {
      console.log(error);
      notificationError('Error joining conversation');
    }
  };

  const leaveConversation = async chat => {
    try {
      await clientbookApi.delete({
        url: `/chats/${chat.id}/followers/${props.auth.userId}`,
      });
      const updatedFollowers = chat.followers.filter(follower => follower !== props.auth.userId);
      notificationSuccess('Conversation Left');
      if (props.messaging.client.chat_id === chat.id) {
        setMsgFollowers(updatedFollowers);
      }
      console.log({ updatedFollowers });
      updateFollowersConversation(chat.id, updatedFollowers);
    } catch (error) {
      console.log(error);
      notificationError('Error leaving conversation');
    }
  };

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    setAssociatesAssigned(props.chat?.client?.assignedAssociates?.includes(props.auth.userId) ?? false);
  }, [props.chat]);

  const stopEventBubbling = (event, obj) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.currentTarget.id === 'markUnread' && obj) {
      MarkUnread(obj);
    }
    if (event.currentTarget.id === 'removeChat' && obj) {
      if (archived) {
        unarchiveChat(obj);
      } else {
        archiveChat(obj);
      }
    }
    if (event.currentTarget.id === 'chatAssign' && obj) {
      props.setAssignPopup(true);
      props.setHoverAssignId(obj.id);
      props.setFollowers(obj.followers);
      props.setClientOnAssignPopup(obj.client);
    }
    if (event.currentTarget.id === 'leave-conversation' && obj) {
      leaveConversation(obj);
    }
    if (event.currentTarget.id === 'join-conversation' && obj) {
      joinConversation(obj);
    }
    setOpenChatOptions(false);
  };
  let id = 0;
  // eslint-disable-next-line no-return-assign, no-plusplus, no-sequences
  const uid = (() => ((id = 0), () => id++))();

  return (
    <div className="pos-rel pointer" id="view-conversation-wrapper">
      <div
        role="button"
        tabIndex={0}
        id={`${elipsis ? `view-more-elipsis ${uid()}` : `view-conversation ${uid()}`}`}
        className="w-33 h-33 m-btm-10 border-r4 pointer m-right-8 pos-rel"
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          setOpenChatOptions(true);
          setElipsis(true);
        }}
        onKeyDown={() => {
          setOpenChatOptions(true);
          setElipsis(true);
        }}
      >
        <FontAwesomeIcon
          icon={['far', 'ellipsis-h']}
          size="1x"
          className="fs-16 pointer"
          id="view-more-btn"
          style={{ color: 'black', marginTop: '8px' }}
        />
      </div>
      {openChatOptions ? (
        <div className="ChatMoreOptionDiv" id="view-conversation">
          <FontAwesomeIcon
            icon={['fas', 'caret-up']}
            size="1x"
            className="fs-16 pointer"
            style={{ color: 'white', position: 'absolute', top: '-10px', right: '10px' }}
          />
          <ul className="ul-no-style" style={{ zIndex: '100' }} id="mark-unread">
            {!props.msg.isUnread && (
              <li className="flex-row-nospacebetween-nowrap inboxAvatarLILI pointer" id="mark-unread-list-item">
                <button
                  id="markUnread"
                  onClick={e => stopEventBubbling(e, props.chat)}
                  onKeyDown={e => stopEventBubbling(e, props.chat)}
                  type="button"
                  className="border-none w-100-P h-35 inboxAvatarLILI bg-white pointer"
                >
                  <img alt="unread message icon" src="https://dashboard-v2-images.s3.amazonaws.com/unreadMessage.svg" />
                  <span className="fs-12 fw-400 m-left-4 no-text-wrap">Mark as Unread</span>
                </button>
              </li>
            )}
            {!props?.chat?.client?.assignedAssociates.includes(props?.auth?.userId) &&
              props?.chat?.followers?.includes(props?.auth?.userId) && (
                <li
                  className="flex-row-nospacebetween-nowrap inboxAvatarLILI pointer"
                  id="leave-conversation"
                  onClick={e => stopEventBubbling(e, props.chat)}
                  onKeyDown={e => stopEventBubbling(e, props.chat)}
                >
                  <div
                    style={{ marginLeft: '23px', marginTop: '7px', paddingBottom: '4px' }}
                    className="remove-chat"
                    id="leave-conversation"
                  >
                    <FontAwesomeIcon
                      icon="fa-regular fa-arrow-right-from-bracket"
                      size="1x"
                      className="fs-16 pointer"
                      id="leave-conversation"
                      style={{ color: 'black' }}
                    />
                    <span className="fs-12 fw-400 m-left-10 no-text-wrap">Leave</span>
                  </div>
                </li>
            )}
            {props.type === 'store_inbox' &&
              !props?.chat?.client?.assignedAssociates.includes(props?.auth?.userId) &&
              !props?.chat?.followers?.includes(props?.auth?.userId) && (
                <li
                  className="flex-row-nospacebetween-nowrap inboxAvatarLILI pointer"
                  id="join-conversation"
                  onClick={e => stopEventBubbling(e, props.chat)}
                  onKeyDown={e => stopEventBubbling(e, props.chat)}
                >
                  <div
                    style={{ marginLeft: '23px', marginTop: '7px', paddingBottom: '4px' }}
                    className="remove-chat"
                    id="join-conversation"
                  >
                    <FontAwesomeIcon
                      icon="fa-regular fa-arrow-left-to-bracket"
                      size="1x"
                      className="fs-16 pointer"
                      id="join-conversation"
                      style={{ color: 'black' }}
                    />
                    <span className="fs-12 fw-400 m-left-10 no-text-wrap">Join</span>
                  </div>
                </li>
            )}
            {yn(props.auth.merchantConfig.DECLUTTERED_INBOX) && (
              <li
                className="flex-row-nospacebetween-nowrap inboxAvatarLILI"
                onClick={e => stopEventBubbling(e, props.chat)}
                onKeyDown={e => stopEventBubbling(e, props.chat)}
                id="removeChat"
              >
                <div
                  style={{ marginLeft: '23px', marginTop: '7px', paddingBottom: '4px' }}
                  className="remove-chat"
                  id="remove-chat"
                >
                  <FontAwesomeIcon
                    icon={['far', archived ? 'eye' : 'eye-slash']}
                    size="1x"
                    className="fs-16 pointer"
                    id="remove-chat"
                    style={{ color: 'black' }}
                  />
                  <span className="fs-12 fw-400 m-left-10 no-text-wrap">{archived ? 'Open' : 'Close'}</span>
                </div>
              </li>
            )}
            <li className="flex-row-nospacebetween-nowrap pos-rel inboxAvatarLILI pointer">
              <button
                onClick={e => stopEventBubbling(e, props.chat)}
                onKeyDown={e => stopEventBubbling(e, props.chat)}
                id="chatAssign"
                type="button"
                className="border-none w-100-P h-35 inboxAvatarLILI bg-white pointer"
              >
                <FontAwesomeIcon
                  icon="fa-regular fa-user-plus"
                  size="1x"
                  className="fs-16 pointer"
                  id="chatAssign"
                  style={{ color: 'black', left: '23px', position: 'absolute' }}
                />
                <span id="chatAssign" className="fs-12 fw-400 pos-rel" style={{ left: '-10px' }}>
                  Invite
                </span>
              </button>
            </li>
          </ul>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  messaging: state.messaging,
});
export default connect(mapStateToProps, {})(ChatMore);
